import ImgUpload from './imgUpload.vue';
export default ImgUpload;
